import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  cartButtonContainer: {
    minWidth: "48px",
    marginLeft: "8px",
  },
  feedbackButtonContainer: {
    position: "fixed",
    bottom: "16px",
    right: "80px",
    zIndex: 198,
  },
  cartButton: {
    minWidth: "48px",
    minHeight: "30px",
    height: "30px",
    ...shorthands.padding("0px", "8px"),
    "&:hover": {
      backgroundColor: tokens.colorBrandBackgroundHover,
    },
  },
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    minHeight: "48px",
    height: "auto",
    ...shorthands.padding("8px", "16px"),
    alignItems: "center",
    color: tokens.colorNeutralForeground2,
    backgroundColor: tokens.colorNeutralBackground2, // Changed to gray background
    position: "sticky",
    top: 0,
    zIndex: 100,
    "@media (min-width: 500px)": {
      ...shorthands.padding("8px", "0px"),
    },
    "@media (max-width: 499px)": {
      minHeight: "40px",
      ...shorthands.padding("4px", "16px"),
    },
  },
  containerCafePage: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    minHeight: "48px",
    height: "auto",
    backgroundColor: tokens.colorNeutralBackground2, // Changed to gray background
    position: "sticky",
    top: 0,
    zIndex: 100,
    ...shorthands.padding("8px", "16px"),
    alignItems: "center",
    "@media (min-width: 500px)": {
      ...shorthands.padding("8px", "0px"),
    },
    "@media (max-width: 499px)": {
      minHeight: "40px",
      ...shorthands.padding("4px", "16px"),
    },
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    ...shorthands.padding("0px", "16px"),
    "@media (max-width: 499px)": {
      alignItems: "flex-start",
      ...shorthands.gap("8px"),
    },
    "@media (min-width: 500px) and (max-width: 899px)": {
      ...shorthands.padding("0px", "40px"),
    },
    "@media (min-width: 900px) and (max-width: 1239px)": {
      width: "840px",
      marginLeft: "auto",
      marginRight: "auto",
      ...shorthands.padding("0px", "0px"),
    },
    "@media (min-width: 1240px) and (max-width: 1399px)": {
      width: "100%",
      ...shorthands.padding("0px", "200px"),
    },
    "@media (min-width: 1400px)": {
      width: "1040px",
      marginLeft: "auto",
      marginRight: "auto",
      ...shorthands.padding("0px", "0px"),
    },
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1, // Allow left section to grow and take available space
    minWidth: 0,
    "@media (max-width: 499px)": {
      alignItems: "flex-start",
    },
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
  breadcrumbContainer: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
    overflowX: "hidden",
    whiteSpace: "nowrap",
    marginBottom: "0", // Ensure no margin
    paddingTop: "0", // Ensure no padding
    paddingBottom: "0", // Ensure no padding
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      top: "0",
      right: "0",
      width: "20px",
      height: "100%",
      backgroundImage: `linear-gradient(to left, ${tokens.colorNeutralBackground2}, transparent)`,
      pointerEvents: "none",
    },
  },
  backButtonIcon: {
    marginTop: "3px",
    marginRight: "5px",
    cursor: "pointer",
  },
  backButtonText: {
    cursor: "pointer",
  },
});
